// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode> 
  // NOTE: StrictMode is temporarily disabled because it conflicts with 
  // react-beautiful-dnd (v13.x), causing "Unable to find draggable" errors/warnings 
  // in development. See: https://github.com/atlassian/react-beautiful-dnd/issues/2350
  <HelmetProvider>
    <App />
  </HelmetProvider>,
  // </React.StrictMode>
);

